/**
 * 取得済み登記（requested-pictures）用の追加項目同期システム
 * PropertySelectionGridと取得済み登記ポップアップ間で追加項目データを同期するためのユーティリティ
 */

import { createPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const REQUESTED_PICTURES_ADDITIONAL_FIELDS_UPDATE_EVENT =
  "updateRequestedPicturesAdditionalFields";

const { dispatch, addListener } = createPropertyGridPopupSyncSystem<string>(
  REQUESTED_PICTURES_ADDITIONAL_FIELDS_UPDATE_EVENT
);

/**
 * 取得済み登記の追加項目更新イベントを発火する
 * @param additionalFields 更新する追加項目（JSON文字列）
 */
export const dispatchRequestedPicturesAdditionalFieldsUpdate = (
  additionalFields: string
): void => {
  dispatch(additionalFields);
};

/**
 * 取得済み登記の追加項目更新イベントリスナーを追加する
 * @param callback 追加項目が更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addRequestedPicturesAdditionalFieldsUpdateListener = (
  callback: (additionalFields: string) => void
): (() => void) => {
  return addListener(callback);
};
